import { css } from 'styled-components';
import { mixin } from '../helpers/mixins';
import { alignContent, alignItems, alignSelf, flex, flexBasis, flexDirection, flexFlow, flexGrow, flexShrink, flexWrap, justifyContent, justifyItems, justifySelf, order } from '../style';
import { styleForBreakpoints } from '../helpers/media-style';
export const flexMixin = css`
  ${({
  inline = false
}) => styleForBreakpoints(inline, inline => `display: ${inline ? 'inline-flex' : 'flex'};`)}

  ${mixin(flex, 'flex')}
  
  ${mixin(flexBasis, ['flexBasis', 'basis'])}
  ${mixin(flexFlow, ['flexFlow', 'flow'])}
  ${mixin(flexGrow, ['flexGrow', 'grow'])}
  ${mixin(flexShrink, ['flexShrink', 'shrink'])}
  
  ${mixin(order, 'order')}
  
  ${mixin(flexDirection, ['flexDirection', 'direction'])}
  ${mixin(flexWrap, ['flexWrap', 'wrap'])}
  
  ${mixin(justifyContent, ['justifyContent', 'justify'])}
  ${mixin(justifyItems, 'justifyItems')}
  ${mixin(justifySelf, 'justifySelf')}
 
  ${mixin(alignItems, ['alignItems', 'align'])}
  ${mixin(alignContent, 'alignContent')}
  ${mixin(alignSelf, 'alignSelf')}
  
  ${({
  center = false
}) => styleForBreakpoints(center, center => center ? `
          justify-content: center !important;
          align-items: center !important;
        ` : '')}
`;
export const flexKeys = ['inline', 'center', 'flex', 'direction', 'flexDirection', 'wrap', 'flexWrap', 'justify', 'justifyContent', 'justifyItems', 'justifySelf', 'align', 'alignItems', 'alignContent', 'alignSelf', 'basis', 'flexBasis', 'flow', 'flexFlow', 'grow', 'flexGrow', 'shrink', 'flexShrink', 'order'];